<template>
  <div>
    <div class="swiperBox">
      <!-- <img src="../../../static/slider/3.jpg" class="banner" /> -->
      <el-carousel  type="card">
        <el-carousel-item v-for="(item, index) in sliders" :key="index">
          <img :src="item.img" class="swiperimg" />
        </el-carousel-item>
      </el-carousel>
    </div>

    <h2 style="text-align: center">产品中心</h2>
    <el-row class="productWrapper" v-if="!isPhone">
      <el-col :span="6">
        <div>
          <el-menu
            class=""
            background-color="#fff"
            text-color="#000"
            active-text-color="#df002e"
            :default-active="active"
            @select="selectMenu"
            unique-opened
            style="over-flow: hidden"
          >
            <el-submenu
              :index="item.key"
              v-for="(item, index) in menuList"
              :key="index"
            >
              <template slot="title">
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  :index="e.key"
                  v-for="(e, i) in item.list"
                  :key="i"
                  >{{ e.name }}</el-menu-item
                >
              </el-menu-item-group>
            </el-submenu>
          </el-menu>
        </div>
      </el-col>
      <el-col :span="18">
        <div
          class="tabRight"
          v-for="(item, index) in list"
          :key="index"
          v-show="active == item.key"
        >
          <p class="title">{{ item.title }}</p>
          <img :src="item.img[0]" class="img1" />
          <div class="content" v-show="item.contents.length > 0">
            <p class="contentTitle">用途与特点</p>
            <div
              v-for="(e, i) in item.contents"
              :key="i"
              style="font-size: 14px; margin-bottom: 10px"
            >
              <span class="contentItem"></span>
              <span>{{ e }}</span>
            </div>
          </div>
          <p class="title" v-show="item.img[1]">产品参数</p>
          <img :src="item.img[1]" class="img1" />
        </div>
      </el-col>
    </el-row>
    <div v-else>
      <div class="mobileWrapper" v-for="(item, index) in list" :key="index">
        <p class="title">{{ item.name||item.title }}</p>
        <img :src="item.img[0]" class="img1" />
        <div class="content" v-show="item.contents.length > 0">
          <p class="contentTitle">用途与特点</p>
          <div
            v-for="(e, i) in item.contents"
            :key="i"
            style="font-size: 14px; margin-bottom: 10px"
          >
            <span class="contentItem"></span>
            <span>{{ e }}</span>
          </div>
        </div>
        <p class="title" v-show="item.img[1]">产品参数</p>
        <img :src="item.img[1]" class="img1" />
      </div>
    </div>
  </div>
</template>

<script>
import data from "./mock";
export default {
  data() {
    return {
      list: [],
      menuList: [],
      active: "1-1",
      isPhone: false,
      sliders: [
        {
          img: require("../../assets/product/swiper1.jpg"),
        },
        {
          img: require("../../assets/product/swiper2.jpg"),
        },
        {
          img: require("../../assets/product/swiper3.jpg"),
        },
        {
          img: require("../../assets/product/swiper4.jpg"),
        },
        {
          img: require("../../assets/product/swiper5.jpg"),
        },
        {
          img: require("../../assets/product/swiper6.jpg"),
        },
        {
          img: require("../../assets/product/swiper7.jpg"),
        },
      ],
    };
  },
  created() {
    this.list = data.list;
    this.menuList = data.menuList;
    if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
      // 当前设备是移动设备
      console.log("移动端");
      this.isPhone = true;
    } else {
      console.log("PC端");
      this.isPhone = false;
    }
  },
  methods: {
    selectMenu(index, path) {
      this.active = index;
    },
  },
};
</script>

<style scoped>
.banner {
  height: 550px;
  width: 100%;
}
.wrapper {
  padding: 0 50px;
  margin-top: 50px;
}
.tabLeft {
  text-align: left;
}
.tabRight {
  margin-left: 20px;
}
.title {
  text-align: left;
  color: #df002e;
  border-left: 4px solid #df002e;
  padding-left: 10px;
}
.content {
  text-align: left;
  margin: 40px 0;
}

.contentTitle {
  color: #df002e;
  border-left: 4px solid #df002e;
  padding-left: 10px;
}
.contentItem {
  width: 10px;
  height: 10px;
  display: inline-block;
  border-radius: 50%;
  background-color: #df002e;
  margin-right: 10px;
}
.img1 {
  height: 100%;
  width: 85%;
}
/deep/ .el-tabs--left .el-tabs__item.is-left {
  text-align: left;
}
/deep/ .el-submenu .el-menu-item {
  overflow: hidden;
}

.productWrapper {
  width: 90%;
  margin: 0 auto;
}

/* 屏幕设备适配 max-device-width: 415px */
@media screen and (max-device-width: 415px) {
  .swiperBox {
    display: none;
  }
  .banner {
    height: 200px;
    width: 100%;
  }
  .wrapper {
    padding: 0 50px;
    margin-top: 50px;
  }
  .tabLeft {
    text-align: left;
  }
  .mobileWrapper {
    background: #f5f5f5;
    border-radius: 4px;
    width: 90%;
    margin: 30px auto;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
    padding: 10px;
  }
  .title {
    text-align: left;
    color: #df002e;
    border-left: 4px solid #df002e;
    padding-left: 10px;
  }
  .content {
    text-align: left;
    margin: 40px 0;
  }

  .contentTitle {
    color: #df002e;
    border-left: 4px solid #df002e;
    padding-left: 10px;
  }
  .contentItem {
    width: 10px;
    height: 10px;
    display: inline-block;
    border-radius: 50%;
    background-color: #df002e;
    margin-right: 10px;
  }
  .img1 {
    height: 100%;
    width: 100%;
  }
  /deep/ .el-tabs--left .el-tabs__item.is-left {
    text-align: left;
  }

  .productWrapper {
    width: 90%;
    margin: 0 auto;
  }
  .swiperimg {
    border: 1px solid #ccc;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    object-fit: fill;
    height: 300px;
  }
}

.swiperimg {
  border: 1px solid #ccc;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  object-fit: fill;
  /* height: 1000px; */
  width: 100%;
}
</style>